// @flow strict

import React from 'react';
import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import { useLanguageContext } from '~contexts/language-context';

import type { PostNode } from '~types/post';

import * as styles from './helping-hands-preview.module.less';

/**
 * Type for component properties.
 */
type HelpingHandsPreviewProps = {
  post: PostNode,
};

/**
 * Component to display preview for helping hands blog post.
 *
 * @param {HelpingHandsPreviewProps} props - Component props
 *
 * @returns {Node}
 */
export const HelpingHandsPreview = ({ post }: HelpingHandsPreviewProps) => {
  const { loc } = useLanguageContext();

  // render nothing if post is missing
  if (post == null) {
    return null;
  }

  const { permalink, title, portrait, thumbnail } = post.frontmatter;

  // helping hands posts have special portrait preview images
  // of not defined, use default thumbnail as preview
  const imageSrc =
    portrait == null
      ? thumbnail.childImageSharp.gatsbyImageData
      : portrait.childImageSharp.gatsbyImageData;

  return (
    <article className={styles.post}>
      <Link to={permalink}>
        <figure>
          <GatsbyImage
            className={styles.image}
            image={imageSrc}
            alt="Helping Hands Image"
          />
        </figure>

        <div className={styles.content}>
          <header>
            <h2 className={styles.headline}>{title}</h2>
          </header>

          <span className={styles.link}>
            {loc('_helping_hands_see_more')} &gt;
          </span>
        </div>
      </Link>
    </article>
  );
};
